import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/components/DashboardLayout'
import DashboardMainView from '@/components/DashboardMainView'
import MarketView from '@/components/MarketView'
import SettingsView from '@/components/SettingsView'
import PlansView from '@/components/Plans'
import Backtester from '@/components/Backtester'
import LoginLayout from '@/components/LoginLayout'
import LoginForm from '@/components/LoginForm'
import SignupForm from '@/components/SignupForm'
import VerifyMail from '@/components/VerifyMail'
import ForgotPasswordStep1 from '@/components/ForgotPasswordStep1'
import ForgotPasswordStep2 from '@/components/ForgotPasswordStep2'
import ForgotPasswordStep3 from '@/components/ForgotPasswordStep3'
import NewChart from '@/components/chart_backtest'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/dashboard',
      component: DashboardLayout,
      children: [{
        path: 'overview',
        component: DashboardMainView
      }, {
        path: 'market',
        component: MarketView
      }, {
        path: '/backtest/:strategy_id',
        name: 'backtest',
        component: Backtester
      }, {
        path: 'new_chart',
        name: 'NewChart',
        component: NewChart
      },{
        path: '/subscription/edit/:subscription_id',
        name: 'edit_subscription',
        component: Backtester,
        props: {editingSubscription: true}
      }, {
        path: 'settings',
        name: 'settings',
        component: SettingsView
      },{
        path: 'plans',
        name: 'plans',
        component: PlansView
      }]
    }, {
      path: '/login',
      component: LoginForm,
      // props: {bgImage: 'login.jpg'},
      // children: [{
      //   path: '/',
      //   component: LoginForm
      // }]
    },{
      path: '/signup',
      component: LoginLayout,
      props: {bgImage: 'register.png'},
      children: [{
        path: '/',
        component: SignupForm
      }]
    }, {
      path: '/check-mail',
      component: LoginLayout,
      props: {bgImage: 'register.png'},
      children: [{
        path: '/',
        component: VerifyMail
      }]
    }, {
      path: '/forgot-password',
      component: LoginLayout,
      props: {bgImage: 'forgot-password.png'},
      children: [{
        path: '/',
        component: ForgotPasswordStep1
      }]
    }, {
      path: '/mail-sent',
      component: LoginLayout,
      props: {bgImage: 'forgot-password.png'},
      children: [{
        path: '/',
        component: ForgotPasswordStep2
      }]
    }, {
      path: '/reset-password/:token',
      component: LoginLayout,
      props: {bgImage: 'forgot-password.png'},
      children: [{
        path: '/',
        component: ForgotPasswordStep3
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js